<template>
  <div style="text-align:center;">
    <table border="1" style="border-bottom:0">
      <!-- 第1行(1表) -->
      <tr style="height:100px">
        <td width="25%" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="50%" class="titleSpan tableTitle">安 全 评 价 风 险 分 析 表</td>
        <td style="border:0" class="titleSpan">BTHL-GK-001</td>
      </tr>
    </table>
    <table border="1">
      <!-- 第2行(2表) -->
      <tr style="height:50px">
        <td width="10%" class="titleSpan">项目名称</td>
        <td class="contentSpan">{{printData.company_name}}</td>
      </tr>
      <!-- 第3行(2表) -->
      <tr style="height:50px">
        <td width="10%" class="titleSpan">类 别</td>
        <td style="height:50px">
          <ul class="pjTypeList">
            <li v-for="item in pjTypeList" :key="item.id">
              <div style="margin-right:5px">{{item.label + "："}}</div>
              <div style="padding-top:2px;">
                <img
                  style="width:15px"
                  v-if="item.id ==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </li>
          </ul>
        </td>
      </tr>
      <!-- 第3行(2表) -->
      <tr style="height:200px">
        <td width="10%" class="titleSpan" style="padding: 0 15px">项目存在的主要危险有害因素</td>
        <td class="contentSpan">{{printData.company_name}}</td>
      </tr>
      <!-- 第4行(2表) -->
      <tr style="height:60px">
        <td width="10%" class="titleSpan" style="padding: 0 15px">参与风险分析人员</td>
        <td class="contentSpan">{{printData.company_name}}</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <!-- 第5行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">序号</td>
        <td width="50%" class="titleSpan">风险分析内容</td>
        <td width="22%" class="titleSpan">结论</td>
        <td>备注</td>
      </tr>
      <!-- 1---- 第6行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">1</td>
        <td width="50%" class="titleSpan titleSpanTAL">委托方具备委托资质，评价项目是否合法</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_1st==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_1st!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
      <!-- 2---- 第7行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">2</td>
        <td width="50%" class="titleSpan titleSpanTAL">委托方的行业安全风险是否能够承受并控制</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_2nd==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_2nd!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
      <!-- 3---- 第8行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">3</td>
        <td
          width="50%"
          class="titleSpan titleSpanTAL"
        >是否在本机构的资质业务范围之内；公司是否具有满足合同要求的能力（人员条件、设备条件、时间要求等）</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_3rd==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_3rd!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
      <!-- 4---- 第9行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">4</td>
        <td width="50%" class="titleSpan titleSpanTAL">本机构安全评价人员的技术能力、技术构成（专业配置）是否符合</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_4th==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_4th!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
      <!-- 5---- 第10行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">5</td>
        <td width="50%" class="titleSpan titleSpanTAL">委托方的营业执照和其他法定的证件是否齐全</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_5th==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_5th!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
      <!-- 6---- 第11行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">6</td>
        <td width="50%" class="titleSpan titleSpanTAL">评价所需的主要基础资料是否具备</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_6th==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_6th!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
      <!-- 7---- 第12行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">7</td>
        <td width="50%" class="titleSpan titleSpanTAL">安全隐患短时期内是否能整改到位</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_7th==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_7th!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
      <!-- 8---- 第13行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">8</td>
        <td width="50%" class="titleSpan titleSpanTAL">评价费用是否低于市场价或预期利润低</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_8th==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_8th!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
      <!-- 9---- 第14行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">9</td>
        <td width="50%" class="titleSpan titleSpanTAL">业主是否提出无理要求</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_9th==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_9th!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
      <!-- 10---- 第15行(3表) -->
      <tr style="height:50px">
        <td width="5%" class="titleSpan">10</td>
        <td width="50%" class="titleSpan titleSpanTAL">公司是否有能力赔偿由于安全评价原因造成事故的损失</td>
        <td width="22%" class="titleSpan">
          <div class="yesOrNo">
            <div class="yesOrNoItem">
              <div>是</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_10th==1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
            <div class="yesOrNoItem" style="margin-left: 20px;">
              <div>/否</div>
              <div style="padding-top:2px;margin-left:10px;">
                <img
                  style="width:15px"
                  v-if="printData.analysis_10th!=1"
                  src="../../assets/image/tableSelected_selected.png"
                  alt
                />
                <img
                  style="width:15px"
                  v-else
                  src="../../assets/image/tableSelected_unselected.png"
                  alt
                />
              </div>
            </div>
          </div>
        </td>
        <td class="contentSpan">remark</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <!-- 第16行(4表) -->
      <tr style="height:200px">
        <td style="width:12%">分析结论</td>
        <td style="height: 200px;">
          <div class="riskBox">
            <div class="riskItem">
              <div>1、该项目安全风险是否可控：</div>
              <div class="riskSelect" style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;margin-left:10px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left: 20px;">
                  <div>/否</div>
                  <div style="padding-top:2px;margin-left:10px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="riskItem">
              <div>2、是否可以开展安全评价工作：</div>
              <div class="riskSelect" style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;margin-left:10px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left: 20px;">
                  <div>/否</div>
                  <div style="padding-top:2px;margin-left:10px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align:right">年月日</div>
          </div>
        </td>
      </tr>
      <tr style="height:100px">
        <td style="width:12%">分析结论</td>
        <td style="height: 100px;">
          <div class="riskBox2">
            <div style="text-align:left;padding:10px;">{{'123123123'}}</div>
            <div style="text-align:right;left;padding:10px;">年月日</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>